import React from "react";

import { ListStyled } from "../../theme";

import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";

export const ModelsDetail = ({ model, isActive, Edit, Select, Delete }) => {
  const editHandler = () => Edit(model);
  const selectHandler = () => Select(model);
  const deleteHandler = () => Delete(model.id);
  return (
    <ListStyled isActive={isActive}>
      <div className="detail" onClick={selectHandler}>
        {model.name}
        {/* <span>{model.brand.name}</span> */}
      </div>
      <span className="edit" onClick={editHandler}>
        <EditOutlinedIcon />
      </span>
      <span className="delete" onClick={deleteHandler}>
        <DeleteOutlineOutlinedIcon />
      </span>
    </ListStyled>
  );
};
